import { ISubMenuItem } from '@models/IHeader';
import updateDataLayer from '@utils/helpers/gtm';
import LinksList from './LinksList';
import NavigationCard from './NavigationCard';

interface Props {
  readonly activeTab: ISubMenuItem;
  readonly subCategory: string;
  readonly mainCategory: string;
  readonly dataTestId?: string;
}

const SubNavTab = ({
  activeTab,
  mainCategory,
  subCategory,
  dataTestId,
}: Props) => {
  const handleLevelThreeClick = (item?: string) => {
    updateDataLayer({
      event: 'menuUsed',
      content_type: 'header_menu_level_3',
      main_category: mainCategory,
      sub_category: subCategory,
      tertiary_category: item,
    });
  };

  return (
    <div
      className="ml-4 mr-4 flex min-h-[418px] cursor-default flex-col pb-24 lgm:ml-0 lgm:mr-0 lgm:flex-row lgm:pl-[9.5rem] xl:absolute xl:left-0 xl:right-0 xl:top-[100%] xl:bg-grey-200"
      data-testid={dataTestId}
    >
      <div className="grid grid-flow-row auto-rows-max md:grid-cols-2 md:gap-x-8 lgm:w-8/12 xl:grid-cols-3 2xl:grid-cols-4 2xl:gap-5">
        {activeTab?.navigationCards?.map(({ image, link }, index) => (
          <NavigationCard
            key={`level-3-card-${link?.name}`}
            image={image}
            link={link}
            classes="lgm:mr-12 mt-8 lg:mt-28"
            onClick={handleLevelThreeClick}
            dataTestId={`CT-01-Header-Sub-Nav-Tab-Navigation-Card-${index}`}
          />
        ))}
      </div>

      <LinksList
        links={activeTab?.links || []}
        onClick={handleLevelThreeClick}
        dataTestId="CT-01-Header-Sub-Nav-Tab-Links-List"
      />
    </div>
  );
};

export default SubNavTab;
